import {Component, EventEmitter, Input, Output} from "@angular/core";

@Component({
    selector: 'db-pagination-controls',
    templateUrl: './pagination-controls.component.html',
    styleUrls: ['./pagination-controls.component.scss'],
    standalone: false
})
export class PaginationControlsComponent {

  @Input() currentPage: number = 1;
  @Input() pagesCount: number = 1;
  @Input() itemsPerPage: number = 20;
  @Input() itemsCount: number = 20;
  @Output() onChangePage = new EventEmitter<number>();

  constructor() {}

  private pages = [];

  public changePage(event: any, page: number): void {
    event.preventDefault();
    if (page === this.currentPage) {
      return;
    }
    this.currentPage = page;
    this.onChangePage.emit(page);
  }

}
